import { Button } from "antd";
import styles from "./index.module.css";
import carretDown from "assets/svg/CaretDown.svg";
import { useState } from "react";

type Props = {
  unavailableWeekdays: any[];
  unavailableDates: any[];
  dateRangeUnavailableDates: any[];
};

export const NotWorkingDaysComponent = ({
  unavailableWeekdays,
  dateRangeUnavailableDates,
  unavailableDates,
}: Props) => {
  const [dateIsOpen, setDateIsOpen] = useState(false);

  return (
    <div className={styles.dateWrapper}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          lineHeight: "24px",
          marginBottom: 10,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 21 }}>Not working Dates & Days</div>
        <Button
          type="text"
          className={styles.expandBtn}
          icon={<img src={carretDown} alt="carretDown" style={dateIsOpen ? { transform: "rotate(180deg)" } : null} />}
          onClick={() => {
            setDateIsOpen((prev) => !prev);
          }}
        >
          {dateIsOpen ? "Collapse" : "Expand"}
        </Button>
      </div>
      {dateIsOpen && (
        <div className={styles.dateContentWrapper}>
          <div className={styles.notWorkingDaysWrapper}>
            <div>Not working days</div>
            <div className={styles.notWorkingDays}>
              {unavailableWeekdays?.length ? unavailableWeekdays.join("s, ") + "s" : ""}
            </div>
          </div>
          <div className={styles.daysAndRangeWrapper}>
            <div className={styles.days}>
              <div>Days</div>
              <div className={styles.notWorkingDays}>
                {unavailableDates.map((s, i) => (
                  <span
                    key={i}
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: "black",
                      marginRight: 10,
                      flex: "1 1 1",
                      boxSizing: "border-box",
                      minWidth: "50px",
                    }}
                  >
                    {new Date(s).toLocaleDateString("EN", { month: "short", day: "numeric" })}
                  </span>
                ))}
              </div>
            </div>
            <div className={styles.range}>
              <div>Date Ranges</div>
              <div>
                {dateRangeUnavailableDates.map((s, i) => (
                  <div
                    key={i}
                    style={{
                      fontSize: 18,
                      fontWeight: 500,
                      color: "black",
                      lineHeight: "18px",
                      marginTop: i !== 0 ? "10px" : "0px",
                      display: "grid",
                      gridTemplateColumns: "1fr 30px 1fr",
                      justifyContent: "space-between",
                      maxWidth: 150,
                      gap: 5,
                    }}
                  >
                    <div style={{ width: "65px", textAlign: "left" }}>
                      {new Date(s.from).toLocaleDateString("EN", {
                        month: "short",
                        day: "numeric",
                      })}
                    </div>
                    <div style={{ margin: "0 auto" }}>-</div>
                    <div style={{ width: "65px", textAlign: "left" }}>
                      {new Date(s.to).toLocaleDateString("EN", { month: "short", day: "numeric" })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
